import InviteEmployeeForm from "../../../../components/company/workforce/onboarding/invite-employee-form";



const InviteEmployeePage = () => {
    return <InviteEmployeeForm />
}

export default InviteEmployeePage;